import './App.css';
import { Searchbar } from './components/Searchbar';
import { MantineProvider, Modal, Text, Anchor } from '@mantine/core';
import { Login } from './components/Login';
import { useState, useEffect } from 'react';
import { Logout } from './components/Logout';
import { useThemeDetector, performLogout, setConfiguration } from './components/Helpers';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router-dom';
import { Callback } from './components/Callback';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const isDarkTheme = useThemeDetector();
  const colorScheme = isDarkTheme ? 'dark' : 'light';
  const [showSessionError, setShowSessionError] = useState(false);

  function closeSessionErrorDialog() {
      setShowSessionError(false);
      performLogout();
  }

  window.onbeforeunload = function(event) {
    if (sessionStorage.getItem('authenticated') && sessionStorage.getItem('expiredSession')) {
      setAuthenticated(false);
      sessionStorage.removeItem('authenticated');
      sessionStorage.removeItem('sessionId');
      sessionStorage.removeItem('enableEdit');
      sessionStorage.removeItem('expiredSession');
      sessionStorage.removeItem('isLocalAirportTime');
    }
  };

  useEffect(() => getConfiguration(), []);

  function getConfiguration() {
    fetch('/tobt/configuration.json', {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST',
        'X-Saab-Application': 'aerobahn-tobt',
        'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Authorization',
    } 
    }).then(function (response) {
      return response.json();
    })
    .then(function (result) {
      setConfiguration(result);
    });
  } 

  return (
    <div>
      { (!authenticated && !sessionStorage.getItem('authenticated')) ? 
        <MantineProvider theme={{ breakpoints: {
          xs: '25em',
          sm: '45em',
          md: '62em',
          lg: '100em',
          xl: '125em',
        }, colorScheme: 'light' }} withGlobalStyles withNormalizeCSS>
            <div className="loginPage">
              <header className="App-header">
                <Router basename="/tobt">
                  <Routes>
                    <Route path='/' element={<Login updateAuthenticated={setAuthenticated}/>}>
                      <Route path='callback' element={<Callback updateAuthenticated={setAuthenticated}/>} />
                    </Route>
                  </Routes>
                </Router>
              </header>
            </div>
        </MantineProvider>
      : null }
      { sessionStorage.getItem('authenticated') ? 
              <MantineProvider theme={{ breakpoints: {
                xs: '25em',
                sm: '45em',
                md: '62em',
                lg: '100em',
                xl: '125em',
              }, colorScheme: colorScheme }} withGlobalStyles withNormalizeCSS>
                  <div className="App">
                    <header className="App-header">
                      <Logout isDarkTheme={isDarkTheme} updateShowSessionError={setShowSessionError}></Logout>
                      <Searchbar isDarkTheme={isDarkTheme} updateShowSessionError={setShowSessionError}></Searchbar>
                      <Modal opened={showSessionError} onClose={closeSessionErrorDialog} withCloseButton={false}>
                        <div>
                            <p style={{fontSize:'17px', textAlign:'center'}}>
                                Your session is no longer valid. You will be returned to the login screen.
                            </p>
                            <Text style={{padding:'10px'}} align="center" mt="md">
                                <Anchor<"a">
                                    href="#"
                                    weight={700}
                                    onClick={closeSessionErrorDialog}
                                >
                                Dismiss
                                </Anchor>
                            </Text>
                        </div>
                      </Modal>
                    </header>
                  </div>
              </MantineProvider>
      : null }
    </div>
    
  );
}

export default App;
